"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusElement = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = require("react");
var _FocusContext = require("../context/FocusContext");
const useFocusElement = _ref => {
  let {
    targetRef,
    onFocus,
    onKeyDown,
    onBlur,
    circular,
    includeEndKey = true,
    includeHomeKey = true
  } = _ref;
  const {
    getFocusProps,
    activeElement
  } = (0, _FocusContext.useFocusContext)();
  const [tabIndex, setTabIndex] = (0, _react.useState)(activeElement === undefined ? undefined : -1);
  const localRef = (0, _react.useRef)(null);
  const ref = (0, _lodestarUtils.useForkRef)(localRef, targetRef);
  const focusProps = activeElement === undefined ? {
    onFocus,
    onKeyDown,
    onBlur
  } : getFocusProps({
    onFocus,
    onKeyDown,
    onBlur,
    circular,
    includeEndKey,
    includeHomeKey
  });
  (0, _react.useEffect)(() => {
    if (activeElement !== undefined) {
      setTabIndex(activeElement === localRef.current ? 0 : -1);
    }
  }, [activeElement]);
  return {
    tabIndex,
    ref,
    ...focusProps
  };
};
exports.useFocusElement = useFocusElement;
//# sourceMappingURL=useFocusElement.js.map